import { Button, ColorPicker, Slider } from "antd";
import { memo, useState } from "react";
import { MdClose } from "react-icons/md";
import styled from "styled-components";

interface StyleLineProps {
    layer: any;
    onDeleted: () => void;
}
const StyleLine = (props: StyleLineProps) => {
    const [lineColor, setLineColor] = useState<string>(props.layer.paint['line-color']);
    const [lineWidth, setLineWidth] = useState<number>(props.layer.paint['line-width']);
    const [lineOpacity, setOpacity] = useState<number>(props.layer.paint['line-opacity']);

    return <>
        <UI_Wrapper>
            <UI_Title_Wrapper>
                <UI_Content_Title>
                    {`Đường (${props.layer['source-layer']})`}
                </UI_Content_Title>
                <Button type="text" style={{ padding: 8 }} onClick={() => {
                    props.onDeleted();
                    window.map?.removeLayer(props.layer.id);
                }}>
                    <MdClose color="red" />
                </Button>
            </UI_Title_Wrapper>

            <UI_Content_Row>
                <UI_Content_Row_Label>Màu đường</UI_Content_Row_Label>
                <UI_Content_Row_Value>
                    <ColorPicker
                        value={lineColor}
                        onChange={(value) => {
                            window.map?.setPaintProperty(props.layer.id, 'line-color', value.toHexString());
                            setLineColor(value.toHexString());
                        }}
                    />
                </UI_Content_Row_Value>
            </UI_Content_Row>

            <UI_Content_Row>
                <UI_Content_Row_Label>Độ rộng (px)</UI_Content_Row_Label>
                <UI_Content_Row_Value>
                    <Slider
                        style={{ width: '100%' }}
                        value={lineWidth}
                        onChange={(value) => {
                            window.map?.setPaintProperty(props.layer.id, 'line-width', value);
                            setLineWidth(value);
                        }}
                        step={1}
                        min={1}
                        max={20}
                    />
                </UI_Content_Row_Value>
            </UI_Content_Row>

            <UI_Content_Row>
                <UI_Content_Row_Label>Độ mờ đục (px)</UI_Content_Row_Label>
                <UI_Content_Row_Value>
                    <Slider
                        style={{ width: '100%' }}
                        value={lineOpacity}
                        onChange={(value) => {
                            window.map?.setPaintProperty(props.layer.id, 'line-opacity', value);
                            setOpacity(value);
                        }}
                        step={0.01}
                        min={0}
                        max={1}
                    />
                </UI_Content_Row_Value>
            </UI_Content_Row>
        </UI_Wrapper>
    </>;
}

export default memo(StyleLine);

const UI_Wrapper = styled.div`
    padding: 8px;
`

const UI_Title_Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 8px;
`

const UI_Content_Title = styled.div`
    font-size: 13px;
    font-weight: 600;
    margin-right: 8px;
`

const UI_Content_Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 8px;
`
const UI_Content_Row_Label = styled.div`
    font-size: 14px;
    margin-right: 8px;
    color: #666666;
    flex: 1;
`
const UI_Content_Row_Value = styled.div`
    flex: 1;
`